/*

----- Favourites functionality ----- 
- Adding and removing from favourites ajax callbacks.

*/


//--- Favourites add & remove buttons ---
function favouriteToggleInit () {
    if ($('.add.favourites').length > 0 || $('.remove.favourites').length > 0)
        //Favourites add.
        $('body').on('click', '.remove.favourites', function (event) {
            //Prevent page from navigating to the includes file.
            event.preventDefault();
            let context = $(this);
            let removeButtonName = context.attr("name");
            let isStockline = (context.attr('data-stockline') != undefined ? true : false);
            let buttonType = context.parents('.favouritesContainer');
            // ButtonType 1 = button with text, buttonType 2 = icon button with no text.
            if (buttonType.hasClass('preset1')) {
                buttonType = 1;
            } else {
                buttonType = 0;
            }
            if (context.hasClass('disabled')) {
                return false;
            }
            //Call post url function to determine post location.
            var postUrl = AXISAjax.postUrl($(this), true);
            AXISAjax.post(postUrl, "operation=0&reference=" + removeButtonName + "&stockline=" + isStockline, "json", context).then((data) => {
                // Get response.
                let result = data['data'];
                if (result) {
                    //Adds the returned title text to the button & relevant classes.
                    $(context).attr('class', "add favourites").attr('title', result.titleText);
                    $(context).parents('.favouritesContainer').removeClass('active');
                    //Output notifcation using the text from the response.
                    if (result.notificationText.length > 0) {
                        callouts.create(result.notificationText, 0);
                    }
                    if (buttonType == 1) {
                        context.html(result['button-text']);
                    }
                }
            }).catch((error) => {
                AXISDebug.output(2,error);
            });;
        });
        // Favourites add.
        $('body').on('click', '.add.favourites', function (event) {
            // Prevent page from navigating to the includes file.
            event.preventDefault();
            let context = $(this);
            let removeButtonName = context.attr("name");
            let isStockline = (context.attr('data-stockline') != undefined ? true : false);
            let buttonType = context.parents('.favouritesContainer');
            // ButtonType 1 = button with text, buttonType 2 = icon button with no text.
            if (buttonType.hasClass('preset1')) {
                buttonType = 1;
            } else {
                buttonType = 0;
            }
            if (context.hasClass('disabled')) {
                return false;
            }
            //Call post url function to determine post location.
            var postUrl = AXISAjax.postUrl(context, true);
            AXISAjax.post(postUrl, "operation=1&reference=" + removeButtonName + "&stockline=" + isStockline, "json", context).then((data) => {
                // Get response.
                let result = data['data'];
                if (result) {
                    //Adds the returned title text to the button & relevant classes.
                    $(context).attr('class', 'remove favourites active animated heartBeat').attr('title', result.titleText);
                    $(context).parents('.favouritesContainer').addClass('active');
                    //Output notifcation using the text from the response.
                    if (result.notificationText.length > 0) {
                        callouts.create(result.notificationText, 0);
                    }
                    if (buttonType == 1) {
                        context.html(result['button-text']);
                    }
                    setTimeout(() => {
                        //animation clean up.
                        context.removeClass('.animated heartBeat');
                    }, 1500);
                }

            
            }).catch((error) => {
                AXISDebug.output(2,error);
            });
    });
}

var favourites = $.favourites = {
initialise: () => {
    return favouriteToggleInit();
    }
}
    
export { favourites }